import { commonFragment, routeFragment } from '@cnx-saas/common';

export const articleFragment = `
    id
    packagingOptions {
      packaging {
        packagingCode
        packagingDescription
        articlesPerPackage
        maxStackSize
        dimensions {
          weight
          height
          width
          length
        }
        parent {
          packaging {
            packagingCode
            packagingDescription
            articlesPerPackage
            maxStackSize
            dimensions {
              weight
              height
              width
              length
            }
            liftingSide
          }
          quantityChildrenPerParent
        }
        liftingSide
      }
      maxStackSize
      articlesPerPackage
    }
    externalReference
    name
    weightInKgPerUnit
  `;

export const locationFragment = `
    ${commonFragment}
    owned
    address {
      street
      zipCode
      city
      country
      coordinates {
        latitude
        longitude
      }
    }
    company
    contact {
      firstName
      lastName
      phone
      email
      role
    }
    loadingRequirements
    serviceTime
    openingHours {
      openingHoursType
      openingHoursPerWeekDay {
        weekday
        from
        to
      }
      timezone
    }
    description
  `;

// CAUTION: Keep in sync with `loadEmbeddedFragment`.
export const loadFragment = `
    ${commonFragment}
    content
    additionalInfo
    loadingMillimeter
    weightInKg
    status
    statusChangedAt
    plannedFor
    transportRequirements
    pickUp {
      location {
        ${locationFragment}
      }
      timeWindow {
        start
        end
      }
      articles {
        article {
          ${articleFragment}
        }
        loadedQuantity
      }
      order {
        externalReference
        articles {
          article {
            ${articleFragment}
          }
          totalQuantity
          totalLoadingMillimeter
          totalWeightInKg
        }
      }
    }
    dropOff {
      location {
        ${locationFragment}
      }
      timeWindow {
        start
        end
      }
      articles {
        article {
          ${articleFragment}
        }
        loadedQuantity
      }
      order {
        externalReference
        articles {
          article {
            ${articleFragment}
          }
          totalQuantity
          totalLoadingMillimeter
          totalWeightInKg
        }
      }
    }
  `;
export const loadFragmentWithRoute = `
    ${loadFragment}
    route {
      ${routeFragment}
    }
  `;

/**
 * Same as `loadFragment`, except doesn't contain `pickUp.order`.
 */
// CAUTION: Keep in sync with `loadFragment`.
export const loadEmbeddedFragment = `
    ${commonFragment}
    loadingMillimeter
    weightInKg
    status
    statusChangedAt
    plannedFor
    pickUp {
      location {
        ${locationFragment}
      }
      timeWindow {
        start
        end
      }
      articles {
        article {
          id
          externalReference
        }
        loadedQuantity
      }
    }
    dropOff {
      location {
        ${locationFragment}
      }
      timeWindow {
        start
        end
      }
      articles {
        article {
          ${articleFragment}
        }
        loadedQuantity
      }
    }
  `;

export const loadEmbeddedFragmentWithRoute = `
    ${loadEmbeddedFragment}
    route {
      ${routeFragment}
    }
  `;

export const orderFragment = `
    ${commonFragment}
    deadline
    type
    status
    location {
      ${locationFragment}
    }
    articles {
      article {
        ${articleFragment}
      }
      totalQuantity
      totalLoadingMillimeter
      totalWeightInKg
    }
    loads {
      ${loadEmbeddedFragment}
    }
    customerOrderReference
    customerComment
    internalComment
  `;
